import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "18",
      cy: "18",
      r: "17",
      fill: "#161616",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.7674 10.8912L17.6509 16.0077C17.3866 16.2717 17.2063 16.608 17.1328 16.9743L16.6602 19.34L19.0259 18.8665C19.3921 18.7933 19.7281 18.6137 19.9925 18.3492L25.109 13.2328C25.2627 13.079 25.3847 12.8965 25.4679 12.6956C25.5511 12.4947 25.5939 12.2794 25.5939 12.062C25.5939 11.8446 25.5511 11.6293 25.4679 11.4284C25.3847 11.2275 25.2627 11.045 25.109 10.8912C24.9552 10.7375 24.7727 10.6155 24.5718 10.5323C24.3709 10.4491 24.1556 10.4062 23.9382 10.4062C23.7207 10.4063 23.5054 10.4491 23.3045 10.5323C23.1037 10.6155 22.9211 10.7375 22.7674 10.8912Z",
      stroke: "white",
      "stroke-width": "1.7",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M23.8071 21.1273V23.8074C23.8071 24.2813 23.6189 24.7358 23.2838 25.0709C22.9487 25.406 22.4942 25.5942 22.0203 25.5942H12.193C11.7191 25.5942 11.3741 25.2962 11.0391 24.9612C10.704 24.6261 10.4063 24.2813 10.4062 23.8074V13.9801C10.4062 13.5063 10.5945 13.0518 10.9296 12.7167C11.2647 12.3816 11.7191 12.1934 12.193 12.1934H14.8732",
      stroke: "white",
      "stroke-width": "1.7",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }